import styled from 'styled-components'
import tw from "tailwind-styled-components"

const Wrapper = tw.section`

`;
export default Wrapper
